


















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { statisticsList, exportStatistics } from "@/api/team/team";
import { SERVER_HOST } from "@/global/constants";

@Component
export default class Member extends Vue {
  private statusList = [
    {
      value: "",
      label: "无",
    },
    {
      value: "0",
      label: "否",
    },
    {
      value: "2",
      label: "是",
    },
  ];

  private dataList: object[] = [];
  private total: number | string = 0;
  private experienceCategory: any = [];
  private roleCount: string = "";
  private searchParams: object = {
    uid: "",
    pid: "",
    teamTask: "",
    start_date: null,
    end_date: null,
    page: 1,
    rows: 20,
  };

  private columnsSchema: object[] = [
    {
      title: "任务流 ID",
      key: "pid",
      align: "center",
      width: 100,
    },
    {
      title: "任务流名称",
      key: "pname",
      align: "center",
      width: 120,
    },
    {
      title: "任务 ID",
      key: "mid",
      width: 100,
    },
    {
      title: "任务名称",
      key: "mname",
      width: 120,
    },
    {
      title: "团队任务",
      key: "team_task",
      width: 100,
    },
    {
      title: "用户 ID",
      key: "uid",
      align: "center",
      width: 100,
    },
    {
      title: "做题数量",
      key: "nums",
      align: "center",
      width: 120,
    },
    {
      title: "新增做题题数",
      key: "new_nums",
      align: "center",
      width: 120,
    },
    {
      title: "成功题数",
      key: "snums",
      align: "center",
      width: 120,
    },
    {
      title: "失败总量",
      key: "fnums",
      align: "center",
      width: 120,
    },
    {
      title: "正确率",
      slot: "_rate",
      align: "center",
      width: 120,
    },
    {
      title: "结算方式",
      key: "online",
      align: "center",
      width: 120,
    },
    {
      title: "已结算金额",
      key: "v_amount",
      align: "center",
      width: 120,
    },
    {
      title: "做题时间",
      key: "day",
      align: "center",
      width: 120,
    },
    {
      title: "做题时长",
      key: "cost_time",
      align: "center",
      width: 120,
    },
    {
      title: "提交标注结果",
      key: "submit_desc",
      align: "center",
      width: 200,
      slot: "submit_desc",
    },
    {
      title: "新增标注结果",
      key: "increased",
      align: "center",
      width: 200,
      slot: "increased",
    },
    {
      title: "成功标注结果",
      key: "items",
      align: "center",
      width: 150,
      slot: "items",
    },
    {
      title: "无需标注数量",
      key: "undo_nums",
      align: "center",
      width: 120,
    },
    {
      title: "质检打回数量",
      key: "back_nums",
      align: "center",
      width: 120,
    },
    {
      title: "打回比例",
      slot: "_aaa",
      align: "center",
      width: 120,
    },
    {
      title: "质检数量",
      key: "click_nums",
      align: "center",
      width: 120,
    },
    {
      title: "质检比例",
      slot: "_bbb",
      align: "center",
      width: 120,
    },
    {
      title: "新增标注数量统计",
      slot: "increasedNum",
      align: "center",
      width: 120,
    },
    {
      title: "成功标注数量统计",
      slot: "qcSum",
      align: "center",
      width: 120,
    }
  ];
  private created() {
    this.getList();
  }
  private async getList() {
    let params: any = JSON.parse(JSON.stringify(this.searchParams));
    try {
      const data = (await statisticsList(params)) as any;
      this.$nextTick(() => {
        this.dataList = data.rows;
        this.total = data.total;
      });
    } catch (error) {
      console.log(error);
    }
  }

  // 搜索
  private handleSearch() {
    this.getList();
  }
  // 导出
  private exports() {
    exportStatistics(JSON.stringify(this.searchParams)).then((res) => {
      // 将数据存放到 Blob 对象中
      const blob = new Blob([res as any], { type: "application/vnd.ms-excel" });
      //创建一个空的 a 标签
      let a = document.createElement("a");
      // 将 blob 文件转化为 url 格式并赋值给a标签的 href 属性
      a.href = URL.createObjectURL(blob);
      // 给a标签设置下载链接并命名
      a.setAttribute("download", "excel.xls");
      // 点击事件触发 href
      a.click();
      // 清除 a 标签
      a = null;
    });

    // window.open(SERVER_HOST+'/v1/team/offline/statistics/members/export.json?dataParams=' + JSON.stringify(this.searchParams))
  }
  // 开始日期选择器
  private stimeChange(date) {
    (this.searchParams as any).start_date = date;
  }
  // 开始日期选择器
  private etimeChange(date) {
    (this.searchParams as any).end_date = date;
  }
  // 分页
  private changePage(data) {
    this.searchParams = Object.assign(this.searchParams, {
      page: data,
    });
    this.getList();
  }
  // 重置
  private handlereset() {
    this.searchParams = {
      uid: "",
      pid: "",
      teamTask: "",
      start_date: null,
      end_date: null,
      page: 1,
      rows: 20,
    };
    this.getList();
  }
  //正确率
  private formatRate(row) {
    if (row.nums > 0 && row.snums > 0) {
      return (
        Math.round(
          (Number(row.snums) / (Number(row.snums) + Number(row.fnums))) * 10000
        ) /
          100.0 +
        "%"
      );
    } else {
      return "*";
    }
  }
  //打回比例
  private formatBackRate(row) {
    if (row.pass_nums > 0) {
      return (
        Math.round(
          (Number(row.back_nums) /
            (Number(row.back_nums) + Number(row.pass_nums))) *
            10000
        ) /
          100.0 +
        "%"
      );
    } else {
      return "*";
    }
  }
  //质检比例
  private formatCheckRate(row) {
    if (row.pass_nums > 0 && row.click_nums > 0) {
      return (
        Math.round(
          (Number(row.click_nums) / (Number(row.snums) + Number(row.fnums))) *
            10000
        ) /
          100.0 +
        "%"
      );
    } else {
      return "*";
    }
  }
}
